<div class="container" [style.gap]="selectedSetting ? '16px' : '32px'">
    <ng-container *ngIf="!selectedSetting">
        <div class="title">
            {{ 'ops-setting.tab.console-settings' | translate }}
        </div>
        <div class="tabs">
            <div
                *ngFor="let tab of TABS"
                class="tab"
                data-cy="ops-settings-console-settings-tab"
                (click)="selectTab(tab)">
                <div>{{ tab | translate }}</div>
                <mat-icon class="icon" svgIcon="chevron-right" />
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="selectedSetting">
        <div class="header" (click)="selectTab()">
            <mat-icon class="icon chevron-left" svgIcon="chevron-right" />
            <div>{{ selectedSetting | translate }}</div>
        </div>

        <ng-container *ngIf="selectedSetting == ALARM_GROUPS">
            <app-alarm-groups-console-settings [vessel]="vessel"> </app-alarm-groups-console-settings>
        </ng-container>
    </ng-container>
</div>
